import React from 'react'
import DataTableForCustomPaginationRoute from '../../../../components/DataTableForCustomPaginationRoute'
import { nameSource } from '../domain/info'
import { headers } from '../domain/headers'
import { breadcrumbList } from '../domain/breadcrumb'
import { toolsList } from '../domain/tools'
import Container from '../../../../components/Container'
import { BRL } from '../../../../utils/mask'

const PromotersList = (): JSX.Element => (
  <Container pageTitle="Listagem" breadcrumb={breadcrumbList} tools={toolsList}>
    <DataTableForCustomPaginationRoute
      paginationUrl="partnerships/promoters/pagination"
      source={nameSource}
      notHasChildren
      headers={headers}
      customHeaders={[
        {
          name: 'Comissão por processo',
          field: 'commission_per_process',
          sortable: false,
          element: item => (
            <span>{BRL(Number(item.commission_per_process)).format()}</span>
          )
        }
      ]}
    />
  </Container>
)

export default PromotersList
